import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutPageDialog } from '@/shared/ui';
import { StaggerItem } from '@/shared/ui/animations';
import {
  ListPageBody,
  ListPageLayout,
  PageHeader,
  PageHeaderIdentity,
  PageHeaderTitle,
} from '@/shared/ui/layout';
import { AnalyticsDashboard } from '@/widgets/analytics-dashboard';

export const Analytics = () => {
  const { t } = useTranslation('common');
  const [isAboutOpen, setIsAboutOpen] = useState(false);

  return (
    <div data-testid="dashboard-layout-padded" className="page-layout">
      <ListPageLayout>
        <StaggerItem index={0}>
          <PageHeader>
            <PageHeaderIdentity>
              <PageHeaderTitle info={{ onClick: () => setIsAboutOpen(true) }}>
                {t('analytics.analytics.usageAnalytics')}
              </PageHeaderTitle>
            </PageHeaderIdentity>
          </PageHeader>
        </StaggerItem>

        <ListPageBody>
          <StaggerItem index={1} className="flex min-h-0 flex-1 flex-col">
            <div className="min-h-0 flex-1 overflow-y-auto p-section">
              <AnalyticsDashboard />
            </div>
          </StaggerItem>
        </ListPageBody>
      </ListPageLayout>

      <AboutPageDialog
        open={isAboutOpen}
        onOpenChange={setIsAboutOpen}
        title={t('analytics.analytics.about.title')}
        description={t('analytics.analytics.howYourWorkspaceIsUsing')}
        rows={[]}
      />
    </div>
  );
};
